import { Container, Stack, Typography, darken, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ArrowForward } from '@mui/icons-material';
import { Box } from '@mui/material';

import {
  StyledButton,
  getTransitionStyle,
} from '../../../components/Utils/UIUtils';
import BeinSportsLogo from '../../../assets/images/bein-sports-logo.webp';
import ESPNLogo from '../../../assets/images/espn-logo.webp';
import TUDNLogo from '../../../assets/images/tudn-logo.webp';
import AVCLogo from '../../../assets/images/avc-logo.webp';
import FS1Logo from '../../../assets/images/fs1-logo.webp';
import SkySportLogo from '../../../assets/images/sky-sport-logo.webp';
import USANetworkLogo from '../../../assets/images/usa-network-logo.webp';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';

const LogoElement = ({ theme, children }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '132px',
      height: '88px',
      borderRadius: theme.shape.defaultBorderRadius,
      border: '1px solid',
      borderColor: 'primary.neutral300',
      p: 2,
    }}
  >
    {children}
  </Box>
);

export default function AvailableChannels() {
  const { t } = useTranslation();
  const theme = useTheme();
  const arrowTransitionStyle = getTransitionStyle(theme, ['transform']);

  const logos = [
    {
      imageAlt: 'Bein Sports',
      imageURL: BeinSportsLogo,
    },
    {
      imageAlt: 'ESPN',
      imageURL: ESPNLogo,
    },
    {
      imageAlt: 'TUDN',
      imageURL: TUDNLogo,
    },
    {
      imageAlt: 'AVC',
      imageURL: AVCLogo,
    },
    {
      imageAlt: 'FS1',
      imageURL: FS1Logo,
    },
    {
      imageAlt: 'USA Network',
      imageURL: USANetworkLogo,
    },
    {
      imageAlt: 'Sky Sport',
      imageURL: SkySportLogo,
    },
  ];

  return (
    <Container maxWidth="lg">
      <Stack
        justifyContent={'center'}
        alignItems={'center'}
        gap={2}
        sx={{
          p: 4,
          textAlign: 'center',
        }}
      >
        <Stack gap={1} sx={{ width: { xs: '100%', md: '80%' } }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: '24px',
              fontWeight: '700',
              color: 'primary.neutral800',
            }}
          >
            {t('LANDING_PAGES.EURO_QUALIFIERS.AVAILABLE_CHANNELS.TITLE')}
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontSize: '16px', color: 'text.secondary' }}
          >
            {t('LANDING_PAGES.EURO_QUALIFIERS.AVAILABLE_CHANNELS.DESCRIPTION')}
          </Typography>
        </Stack>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: 'repeat(2, 1fr)',
              sm: 'repeat(4, 1fr)',
            },
            gap: 2,
          }}
        >
          {logos.map((logo, index) => (
            <Fragment key={index}>
              <LogoElement theme={theme}>
                <img
                  src={logo.imageURL}
                  alt={logo.imageAlt}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  }}
                />
              </LogoElement>
            </Fragment>
          ))}
          <LogoElement theme={theme}>
            <Typography
              component={Link}
              variant="body1"
              to="/channels"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'primary.neutral800',
                textDecoration: 'none',
              }}
            >
              {t(
                'LANDING_PAGES.EURO_QUALIFIERS.AVAILABLE_CHANNELS.BROWSE_MORE'
              )}
            </Typography>
          </LogoElement>
        </Box>
        <StyledButton
          variant="contained"
          href="/free-trial"
          sx={{
            alignSelf: 'center',
            color: 'white',
            p: '24px 32px',
            mt: 2,
            height: '48px',
            fontWeight: '400',
            border: '1px solid',
            borderColor: '#fa4616',
            backgroundColor: '#fa4616',
            borderRadius: theme.shape.secondaryBorderRadius,
            '&:hover': {
              backgroundColor: darken('#fa4616', 0.1),
              borderColor: darken('#fa4616', 0.1),
            },
            fontSize: { xs: '16px', md: '18px' },
            '&:hover .MuiButton-endIcon ': {
              transform: 'translateX(4px)',
              ...arrowTransitionStyle,
            },
            '& .MuiButton-endIcon': {
              ...arrowTransitionStyle,
            },
          }}
          endIcon={<ArrowForward />}
        >
          {t('LANDING_PAGES.EURO_QUALIFIERS.AVAILABLE_CHANNELS.BUTTON')}
        </StyledButton>
      </Stack>
    </Container>
  );
}
